import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import { CheckCircle2, Receipt } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
import { useOrder } from '../context/OrderContext';
import { useLanguage } from '../context/LanguageContext';
export const Confirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    pickupDate,
    clearCart,
    cartTotal
  } = useOrder();
  const {
    t,
    dateLocale
  } = useLanguage();
  // Get the order number passed from the Cart page
  const orderNumber = location.state?.orderNumber || 'Unknown';
  useEffect(() => {
    if (!pickupDate) {
      navigate('/');
    }
    // We don't clear cart immediately so we can show the total,
    // but in a real app we'd clear it after successful submission.
  }, [pickupDate, navigate]);
  const handleStartNew = () => {
    clearCart();
    navigate('/');
  };
  if (!pickupDate) return null;
  return <PageTransition className="justify-center p-6 text-center bg-terracotta text-white" data-id="element-98">
      <div className="flex-1 flex flex-col items-center justify-center max-w-sm mx-auto w-full" data-id="element-99">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        bounce: 0.5,
        delay: 0.1
      }} data-id="element-100">
          <CheckCircle2 size={80} className="text-cream mb-6" strokeWidth={1.5} data-id="element-101" />
        </motion.div>

        <h1 className="text-4xl font-serif mb-2" data-id="element-102">{t('confirm.heading')}</h1>
        <p className="text-cream/90 mb-8 text-lg" data-id="element-103">{t('confirm.sub')}</p>

        <div className="bg-white text-espresso w-full rounded-2xl p-6 shadow-2xl mb-8 text-left relative overflow-hidden" data-id="element-104">
          <div className="absolute top-0 left-0 w-full h-2 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxMCI+PHBhdGggZD0iTTAgMTBMMTAgMEwyMCAxMEgwWiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==')] -mt-1 opacity-50" data-id="element-105"></div>

          <div className="flex items-center gap-3 mb-4 text-terracotta-dark" data-id="element-106">
            <Receipt size={20} data-id="element-107" />
            <span className="font-medium uppercase tracking-wider text-sm" data-id="element-108">
              {t('confirm.order_num')} #{orderNumber}
            </span>
          </div>

          <div className="space-y-4" data-id="element-109">
            <div data-id="element-110">
              <div className="text-sm text-espresso-light mb-1" data-id="element-111">
                {t('confirm.pickup_date')}
              </div>
              <div className="font-serif text-xl capitalize" data-id="element-112">
                {format(pickupDate, 'EEEE, MMMM do', {
                locale: dateLocale
              })}
              </div>
            </div>

            <div className="pt-4 border-t border-border/50" data-id="element-113">
              <div className="text-sm text-espresso-light mb-1" data-id="element-114">
                {t('confirm.total')}
              </div>
              <div className="font-serif text-2xl" data-id="element-115">{cartTotal} kr</div>
            </div>
          </div>
        </div>

        <p className="text-cream/80 text-sm mb-12" data-id="element-116">
          {t('confirm.instructions')}
        </p>

        <button onClick={handleStartNew} className="w-full bg-white text-terracotta-dark hover:bg-cream rounded-2xl p-4 font-medium transition-colors active:scale-[0.98]" data-id="element-117">
          {t('confirm.new_order')}
        </button>
      </div>
    </PageTransition>;
};